import { generateItems } from 'domain/common';
import { Item } from 'domain/lib';

const { actions, selectors, reducer } = generateItems('Item', Item);

export { actions, selectors, reducer };
